import React from 'react';

interface StepProps {
  formData: {
    isFeatured: boolean;
    badge: string;
  };
  onInputChange: (field: string, value: any) => void;
}

const Step3ProductFeatures: React.FC<StepProps> = ({ formData, onInputChange }) => {
  const badgeOptions = [
    { value: '', label: 'No Badge' },
    { value: 'New', label: 'New' },
    { value: 'Bestseller', label: 'Bestseller' },
    { value: 'Sale', label: 'Sale' },
    { value: 'Limited', label: 'Limited Edition' },
    { value: 'Featured', label: 'Featured' }
  ];

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-gray-800">Product Features</h3>
      
      <div className="space-y-4">
        <div className="flex items-start p-4 bg-gray-50 rounded-lg">
          <input
            id="is_featured"
            type="checkbox"
            checked={formData.isFeatured}
            onChange={(e) => onInputChange('isFeatured', e.target.checked)}
            className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
          />
          <div className="ml-3">
            <label htmlFor="is_featured" className="block text-sm font-medium text-gray-700">
              Mark as featured product
            </label>
            <p className="text-sm text-gray-500">
              Featured products appear prominently on the homepage
            </p>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Add a product badge
          </label>
          <select
            value={formData.badge}
            onChange={(e) => onInputChange('badge', e.target.value)}
            className="block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {badgeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <p className="mt-1 text-sm text-gray-500">
            Badges help highlight special products
          </p>
        </div>
      </div>
    </div>
  );
};

export default Step3ProductFeatures;
